import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchArqueos } from '../actions/arqueos'
import { fetchMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers'

import { renderInputField, renderSelectField } from '../utils/forms'
import CustomersModal from '../components/CustomersModal'

class ArqueosFilterForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      loading: false,
      showCustomersModal: false
    }

    this.submit = this.submit.bind(this)
    this.openCustomers = this.openCustomers.bind(this)
    this.saveCustomers = this.saveCustomers.bind(this)
    this.clearCustomers = this.clearCustomers.bind(this)
  }

  openCustomers() {
    this.setState({ showCustomersModal: true })
  }

  saveCustomers(ids) {
    const { change } = this.props
    // Persist multi-select into form state
    change('Customers', ids)
    this.setState({ showCustomersModal: false })
  }

  clearCustomers() {
    const { change } = this.props
    change('Customers', [])
  }

  componentDidMount() {
    const { role, fetchMachines, fetchCustomers } = this.props

    fetchMachines()

    if (role === 'ADMIN') {
      fetchCustomers()
    }

    this.load(this.props)
  }

  // Keeping the original lifecycle to minimize changes
  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { role, machines, customers, arqueos } = props

    if (!arqueos.loading && arqueos.arqueosNeedRefresh) {
      this.submit(this.props.formValues)
    }

    if (!this.state.loaded && machines && (role !== 'ADMIN' || customers)) {
      this.setState({ loaded: true })
    }
  }

  renderYearOptions() {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let y = currentYear; y >= 2017; y--) {
      years.push(
        <option key={y} value={y}>{y}</option>
      );
    }

    return years;
  }

  submit(props) {
    this.setState({ loading: true });

    const { Year1, Year2, Machine, Country, ContractType, Customers = [] } = props;

    const startDate = Year1 ? `${Year1}-01-01` : '';
    const endDate = Year2 ? `${Year2}-12-31` : '';

    // Always send array of customer IDs
    return this.props.fetchArqueos(
      Machine,
      Customers,
      startDate,
      endDate,
      Country,
      ContractType
    )
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          });
        }

        this.setState({ loading: false });
        return response;
      })
      .catch(error => {
        this.setState({ loading: false });
        throw error;
      });
  }

  render() {
    const { loaded, showCustomersModal } = this.state
    const { error, submitting, handleSubmit, machines, customers, role, formValues } = this.props

    if (!loaded) {
      return (
        <LoadingProgress />
      )
    }

    const selectedIds = formValues.Customers || []
    const selectedCount = selectedIds.length
    const selectedPreview = selectedIds
      .map(id => (customers || []).find(c => c._id === id))
      .filter(Boolean)
      .map(c => c.Fullname)
      .slice(0, 3)

    return (
      <>
        <form onSubmit={handleSubmit(this.submit)} className="mb-3">
          {submitting ? (<div className="row"></div>) : (
            <div className="row">
              <div className="col">
                <Field
                  name="Machine"
                  component={renderSelectField}
                  label="Máquina"
                >
                  <option value="">Todas</option>
                  {machines.map((machine) => (
                    <option value={machine._id} key={machine._id}>
                      {machine.Serial} - {machine.Customer?.Fullname || 'None'}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="col">
                {role === 'ADMIN' && (
                  <div className="form-group">
                    <label>Clientes</label>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm mr-2"
                        onClick={this.openCustomers}
                      >
                        <i className="fas fa-users mr-1"></i>
                        Elegir clientes
                      </button>
                      {selectedCount > 0 ? (
                        <>
                          <span className="small text-muted mr-2">
                            {selectedCount} seleccionado(s){selectedPreview.length ? `: ${selectedPreview.join(', ')}${selectedCount > selectedPreview.length ? '…' : ''}` : ''}
                          </span>
                          <button type="button" className="btn btn-link p-0 small" onClick={this.clearCustomers}>
                            Limpiar
                          </button>
                        </>
                      ) : (
                        <span className="small text-muted">Ninguno seleccionado</span>
                      )}
                    </div>

                    {/* hidden field to store array in redux-form */}
                    <Field
                      name="Customers"
                      component={({ input }) => <input type="hidden" {...input} />}
                    />
                  </div>
                )}
              </div>

              <div className="col">
                {role === 'ADMIN' &&
                  <Field name="ContractType"
                    component={renderSelectField}
                    label="Contrato">
                    <option value="">Todos</option>
                    <option value="REVENUE SHARE">REVENUE SHARE</option>
                    <option value="SPACE RENTAL">SPACE RENTAL</option>
                    <option value="SALE">VENTA</option>
                    <option value="RENTAL">ALQUILER</option>
                  </Field>
                }
              </div>

              <div className="col">
                {role === 'ADMIN' &&
                  <Field name="Country"
                    component={renderSelectField}
                    label="País">
                    <option value="">Todos</option>
                    <option value="España">España</option>
                    <option value="Italia">Italia</option>
                  </Field>
                }
              </div>

              <div className="col">
                <Field name="Year1"
                  component={renderSelectField}
                  label="Año 1">
                  <option value="">Seleccionar</option>
                  {this.renderYearOptions()}
                </Field>
              </div>

              <div className="col">
                <Field name="Year2"
                  component={renderSelectField}
                  label="Año 2">
                  <option value="">Seleccionar</option>
                  {this.renderYearOptions()}
                </Field>
              </div>
            </div>
          )}

          <div className="form-row">
            {error && <div className="alert alert-danger">{error}</div>}
          </div>
          <div className="form-row">
            {submitting ? (<div className="loading-wheel"></div>) : (
              <button className="btn bg-vw-dark text-white mr-1 button-center"
                type="submit"
                disabled={submitting}>
                <i className="fas fa-sync mr-1"></i>
                Aplicar filtros
              </button>
            )}
          </div>
        </form>

        {role === 'ADMIN' && (
          <CustomersModal
            open={showCustomersModal}
            onClose={() => this.setState({ showCustomersModal: false })}
            onSave={this.saveCustomers}
            customers={customers || []}
            initialSelected={selectedIds}
            title="Seleccionar clientes"
          />
        )}
      </>
    )
  }
}

ArqueosFilterForm = reduxForm({
  form: 'ArqueosFilterForm',
})(ArqueosFilterForm)

const selector = formValueSelector('ArqueosFilterForm')

const mapStateToProps = state => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  arqueos: state.arqueos,
  role: state.auth.role,
  initialValues: {
    Machine: '',
    Customers: [],
    Country: '',
    ContractType: '',
    Year1: new Date().getFullYear().toString(),
    Year2: new Date().getFullYear().toString()
  },
  formValues: {
    Machine: selector(state, 'Machine'),
    Customers: selector(state, 'Customers') || [],
    Country: selector(state, 'Country'),
    ContractType: selector(state, 'ContractType'),
    Year1: selector(state, 'Year1'),
    Year2: selector(state, 'Year2'),
  }
})

const mapDispatchToProps = dispatch => ({
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosFilterForm)
